import React from 'react';
import { motion } from 'framer-motion';
import './StudentClubs.css';

const clubs = [
  {
    name: "Hacettepe Bitki Topluluğu (HABİT)",
    description: "Doğanın yeşil dünyasına açılan kapınız! Bitkilerin büyüleyici dünyasını keşfetmek, botanik bilimini anlamak ve çevre bilincini artırmak için bir araya gelen tutkulu öğrencilerin oluşturduğu topluluğumuz, teorik bilgiyi pratikle birleştirerek unutulmaz deneyimler sunuyor.",
    logo: "https://fs.hacettepe.edu.tr/fenyeni/topluluklar/habit.jpg",
    instagram: "https://instagram.com/hacettepebitki"
  },
  {
    name: "Hacettepe Biyoloji Topluluğu (HUBİTO)",
    description: "1998'den beri yaşam bilimlerinin öncü öğrenci topluluğu! Biyolojinin tüm alanlarında akademik ve sosyal etkinlikler düzenleyerek, öğrencilerin mesleki gelişimlerine katkıda bulunuyor ve bilimsel düşünceyi teşvik ediyoruz.",
    logo: "https://fs.hacettepe.edu.tr/fenyeni/topluluklar/biyolojitoplulugu.jpg",
    instagram: "https://www.instagram.com/hubito98/"
  },
  {
    name: "Hacettepe Ekoloji Topluluğu (EKOG)",
    description: "Doğa ve insan arasındaki hassas dengeyi anlamak, ekosistemleri korumak ve sürdürülebilir bir gelecek için çalışan topluluğumuz, çevre bilincini artırmaya yönelik projeler ve etkinlikler düzenliyor.",
    logo: "https://fs.hacettepe.edu.tr/fenyeni/topluluklar/ekog.jpg",
    instagram: "https://instagram.com/huekog"
  },
  {
    name: "Hacettepe Evrimsel Biyoloji ve Tıp Topluluğu (HUEBTTO)",
    description: "Evrimsel biyoloji ve tıp alanlarında interdisipliner bir yaklaşımla bilimsel düşünceyi teşvik eden topluluğumuz, modern biyolojinin temellerini anlama ve uygulama konusunda öğrencilere rehberlik ediyor.",
    logo: "https://fs.hacettepe.edu.tr/fenyeni/topluluklar/huebtto.jpg",
    instagram: "https://www.instagram.com/huebtto/"
  }
];

const StudentClubs = () => {
  return (
    <div className="student-clubs-container">
      <motion.div 
        className="hero-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <h1>Öğrenci Toplulukları</h1>
        <p className="hero-text">
          Hacettepe Üniversitesi Fen Fakültesi bünyesinde faaliyet gösteren öğrenci topluluklarımız, 
          bilimsel düşünceyi teşvik etmek, akademik gelişimi desteklemek ve sosyal etkileşimi artırmak 
          için çalışmaktadır. Her bir topluluğumuz, kendi alanında özgün projeler ve etkinlikler 
          düzenleyerek öğrencilerimizin hem akademik hem de sosyal gelişimlerine katkıda bulunmaktadır.
        </p>
      </motion.div>

      <div className="clubs-grid">
        {clubs.map((club, index) => (
          <motion.div
            key={index}
            className="club-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
          >
            <div className="club-image">
              <img src={club.logo} alt={club.name} />
            </div>
            <div className="club-content">
              <h2>{club.name}</h2>
              <p>{club.description}</p>
              <a 
                href={club.instagram} 
                target="_blank" 
                rel="noopener noreferrer"
                className="instagram-link"
              >
                <i className="fab fa-instagram"></i> Instagram
              </a>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default StudentClubs; 
 